'use strict';

class Tile {
  constructor(position, value) {
    this.x = position.x;
    this.y = position.y;
    this.value = value || 2;

    this.previousPosition = null;
    this.mergedFrom = null;
    this.id = Tile.idCounter++;
  }

  savePosition() {
    this.previousPosition = {
      x: this.x,
      y: this.y,
    };
  }

  updatePosition(position) {
    this.x = position.x;
    this.y = position.y;
  }

  serialize() {
    return {
      position: {
        x: this.x,
        y: this.y,
      },
      value: this.value,
      mergedFrom: this.mergedFrom
        ? this.mergedFrom.map((t) => t.serialize())
        : null,
      id: this.id,
    };
  }
}

Tile.idCounter = 0;

module.exports = Tile;
